/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API Counter
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChangeCounterDto } from '../models';
// @ts-ignore
import type { CounterCreateDto } from '../models';
// @ts-ignore
import type { CounterDto } from '../models';
// @ts-ignore
import type { GetCounterDto } from '../models';
/**
 * CounterApi - axios parameter creator
 * @export
 */
export const CounterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Удаляет счетчик для пользователя (по userId и type).
         * @summary 
         * @param {GetCounterDto} getCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerDeleteCounter: async (getCounterDto: GetCounterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCounterDto' is not null or undefined
            assertParamExists('counterControllerDeleteCounter', 'getCounterDto', getCounterDto)
            const localVarPath = `/counter/deleteCounter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCounterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получает счетчик для пользователя (по userId и type).
         * @summary 
         * @param {GetCounterDto} getCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerGetCounter: async (getCounterDto: GetCounterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getCounterDto' is not null or undefined
            assertParamExists('counterControllerGetCounter', 'getCounterDto', getCounterDto)
            const localVarPath = `/counter/getCounter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getCounterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает список всех счетчиков текущего пользователя, срок действия которых не истек и которые доступны для использования.
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerGetCounters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/counter/getCounters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает список всех счетчиков текущего пользователя.
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerGetCountersByUserId: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('counterControllerGetCountersByUserId', 'userId', userId)
            const localVarPath = `/counter/getCountersByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Увеличивает значение поля spent для счетчика пользователя по заданному типу. Если incrementBy не указан, увеличивает на 1. Если счетчик не найден или недоступен — возвращает ошибку.
         * @summary 
         * @param {ChangeCounterDto} changeCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerIncrementCounterValue: async (changeCounterDto: ChangeCounterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeCounterDto' is not null or undefined
            assertParamExists('counterControllerIncrementCounterValue', 'changeCounterDto', changeCounterDto)
            const localVarPath = `/counter/increment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeCounterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает значение в счетчик пользователя по заданному типу (увеличивает total на incrementBy). Если лимит неограничен (total === null), возврат не требуется. Если счетчик не найден — возвращает ошибку.
         * @summary 
         * @param {ChangeCounterDto} changeCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerRefundCounterValue: async (changeCounterDto: ChangeCounterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeCounterDto' is not null or undefined
            assertParamExists('counterControllerRefundCounterValue', 'changeCounterDto', changeCounterDto)
            const localVarPath = `/counter/refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeCounterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Создает новый счетчик для пользователя или обновляет существующий (по userId и type). Если счетчик не существует — создает новый.
         * @summary 
         * @param {CounterCreateDto} counterCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerUpsertCounter: async (counterCreateDto: CounterCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'counterCreateDto' is not null or undefined
            assertParamExists('counterControllerUpsertCounter', 'counterCreateDto', counterCreateDto)
            const localVarPath = `/counter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-service-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-service-api-key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(counterCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Создает новый счетчик для пользователя или обновляет существующий (по userId и type). Если счетчик не существует — создает новый.
         * @summary 
         * @param {CounterCreateDto} counterCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerUpsertCounterAdmin: async (counterCreateDto: CounterCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'counterCreateDto' is not null or undefined
            assertParamExists('counterControllerUpsertCounterAdmin', 'counterCreateDto', counterCreateDto)
            const localVarPath = `/counter/upsertCounterAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(counterCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CounterApi - functional programming interface
 * @export
 */
export const CounterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CounterApiAxiosParamCreator(configuration)
    return {
        /**
         * Удаляет счетчик для пользователя (по userId и type).
         * @summary 
         * @param {GetCounterDto} getCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async counterControllerDeleteCounter(getCounterDto: GetCounterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.counterControllerDeleteCounter(getCounterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CounterApi.counterControllerDeleteCounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получает счетчик для пользователя (по userId и type).
         * @summary 
         * @param {GetCounterDto} getCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async counterControllerGetCounter(getCounterDto: GetCounterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.counterControllerGetCounter(getCounterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CounterApi.counterControllerGetCounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает список всех счетчиков текущего пользователя, срок действия которых не истек и которые доступны для использования.
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async counterControllerGetCounters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CounterDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.counterControllerGetCounters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CounterApi.counterControllerGetCounters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает список всех счетчиков текущего пользователя.
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async counterControllerGetCountersByUserId(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CounterDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.counterControllerGetCountersByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CounterApi.counterControllerGetCountersByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Увеличивает значение поля spent для счетчика пользователя по заданному типу. Если incrementBy не указан, увеличивает на 1. Если счетчик не найден или недоступен — возвращает ошибку.
         * @summary 
         * @param {ChangeCounterDto} changeCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async counterControllerIncrementCounterValue(changeCounterDto: ChangeCounterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeCounterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.counterControllerIncrementCounterValue(changeCounterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CounterApi.counterControllerIncrementCounterValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает значение в счетчик пользователя по заданному типу (увеличивает total на incrementBy). Если лимит неограничен (total === null), возврат не требуется. Если счетчик не найден — возвращает ошибку.
         * @summary 
         * @param {ChangeCounterDto} changeCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async counterControllerRefundCounterValue(changeCounterDto: ChangeCounterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeCounterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.counterControllerRefundCounterValue(changeCounterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CounterApi.counterControllerRefundCounterValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Создает новый счетчик для пользователя или обновляет существующий (по userId и type). Если счетчик не существует — создает новый.
         * @summary 
         * @param {CounterCreateDto} counterCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async counterControllerUpsertCounter(counterCreateDto: CounterCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.counterControllerUpsertCounter(counterCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CounterApi.counterControllerUpsertCounter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Создает новый счетчик для пользователя или обновляет существующий (по userId и type). Если счетчик не существует — создает новый.
         * @summary 
         * @param {CounterCreateDto} counterCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async counterControllerUpsertCounterAdmin(counterCreateDto: CounterCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.counterControllerUpsertCounterAdmin(counterCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CounterApi.counterControllerUpsertCounterAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CounterApi - factory interface
 * @export
 */
export const CounterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CounterApiFp(configuration)
    return {
        /**
         * Удаляет счетчик для пользователя (по userId и type).
         * @summary 
         * @param {GetCounterDto} getCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerDeleteCounter(getCounterDto: GetCounterDto, options?: RawAxiosRequestConfig): AxiosPromise<CounterDto> {
            return localVarFp.counterControllerDeleteCounter(getCounterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Получает счетчик для пользователя (по userId и type).
         * @summary 
         * @param {GetCounterDto} getCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerGetCounter(getCounterDto: GetCounterDto, options?: RawAxiosRequestConfig): AxiosPromise<CounterDto> {
            return localVarFp.counterControllerGetCounter(getCounterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает список всех счетчиков текущего пользователя, срок действия которых не истек и которые доступны для использования.
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerGetCounters(options?: RawAxiosRequestConfig): AxiosPromise<Array<CounterDto>> {
            return localVarFp.counterControllerGetCounters(options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает список всех счетчиков текущего пользователя.
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerGetCountersByUserId(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CounterDto>> {
            return localVarFp.counterControllerGetCountersByUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Увеличивает значение поля spent для счетчика пользователя по заданному типу. Если incrementBy не указан, увеличивает на 1. Если счетчик не найден или недоступен — возвращает ошибку.
         * @summary 
         * @param {ChangeCounterDto} changeCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerIncrementCounterValue(changeCounterDto: ChangeCounterDto, options?: RawAxiosRequestConfig): AxiosPromise<ChangeCounterDto> {
            return localVarFp.counterControllerIncrementCounterValue(changeCounterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает значение в счетчик пользователя по заданному типу (увеличивает total на incrementBy). Если лимит неограничен (total === null), возврат не требуется. Если счетчик не найден — возвращает ошибку.
         * @summary 
         * @param {ChangeCounterDto} changeCounterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerRefundCounterValue(changeCounterDto: ChangeCounterDto, options?: RawAxiosRequestConfig): AxiosPromise<ChangeCounterDto> {
            return localVarFp.counterControllerRefundCounterValue(changeCounterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Создает новый счетчик для пользователя или обновляет существующий (по userId и type). Если счетчик не существует — создает новый.
         * @summary 
         * @param {CounterCreateDto} counterCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerUpsertCounter(counterCreateDto: CounterCreateDto, options?: RawAxiosRequestConfig): AxiosPromise<CounterDto> {
            return localVarFp.counterControllerUpsertCounter(counterCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Создает новый счетчик для пользователя или обновляет существующий (по userId и type). Если счетчик не существует — создает новый.
         * @summary 
         * @param {CounterCreateDto} counterCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        counterControllerUpsertCounterAdmin(counterCreateDto: CounterCreateDto, options?: RawAxiosRequestConfig): AxiosPromise<CounterDto> {
            return localVarFp.counterControllerUpsertCounterAdmin(counterCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CounterApi - object-oriented interface
 * @export
 * @class CounterApi
 * @extends {BaseAPI}
 */
export class CounterApi extends BaseAPI {
    /**
     * Удаляет счетчик для пользователя (по userId и type).
     * @summary 
     * @param {GetCounterDto} getCounterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounterApi
     */
    public counterControllerDeleteCounter(getCounterDto: GetCounterDto, options?: RawAxiosRequestConfig) {
        return CounterApiFp(this.configuration).counterControllerDeleteCounter(getCounterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получает счетчик для пользователя (по userId и type).
     * @summary 
     * @param {GetCounterDto} getCounterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounterApi
     */
    public counterControllerGetCounter(getCounterDto: GetCounterDto, options?: RawAxiosRequestConfig) {
        return CounterApiFp(this.configuration).counterControllerGetCounter(getCounterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает список всех счетчиков текущего пользователя, срок действия которых не истек и которые доступны для использования.
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounterApi
     */
    public counterControllerGetCounters(options?: RawAxiosRequestConfig) {
        return CounterApiFp(this.configuration).counterControllerGetCounters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает список всех счетчиков текущего пользователя.
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounterApi
     */
    public counterControllerGetCountersByUserId(userId: string, options?: RawAxiosRequestConfig) {
        return CounterApiFp(this.configuration).counterControllerGetCountersByUserId(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Увеличивает значение поля spent для счетчика пользователя по заданному типу. Если incrementBy не указан, увеличивает на 1. Если счетчик не найден или недоступен — возвращает ошибку.
     * @summary 
     * @param {ChangeCounterDto} changeCounterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounterApi
     */
    public counterControllerIncrementCounterValue(changeCounterDto: ChangeCounterDto, options?: RawAxiosRequestConfig) {
        return CounterApiFp(this.configuration).counterControllerIncrementCounterValue(changeCounterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает значение в счетчик пользователя по заданному типу (увеличивает total на incrementBy). Если лимит неограничен (total === null), возврат не требуется. Если счетчик не найден — возвращает ошибку.
     * @summary 
     * @param {ChangeCounterDto} changeCounterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounterApi
     */
    public counterControllerRefundCounterValue(changeCounterDto: ChangeCounterDto, options?: RawAxiosRequestConfig) {
        return CounterApiFp(this.configuration).counterControllerRefundCounterValue(changeCounterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Создает новый счетчик для пользователя или обновляет существующий (по userId и type). Если счетчик не существует — создает новый.
     * @summary 
     * @param {CounterCreateDto} counterCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounterApi
     */
    public counterControllerUpsertCounter(counterCreateDto: CounterCreateDto, options?: RawAxiosRequestConfig) {
        return CounterApiFp(this.configuration).counterControllerUpsertCounter(counterCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Создает новый счетчик для пользователя или обновляет существующий (по userId и type). Если счетчик не существует — создает новый.
     * @summary 
     * @param {CounterCreateDto} counterCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CounterApi
     */
    public counterControllerUpsertCounterAdmin(counterCreateDto: CounterCreateDto, options?: RawAxiosRequestConfig) {
        return CounterApiFp(this.configuration).counterControllerUpsertCounterAdmin(counterCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}

